/**
 * @generated SignedSource<<b74cf2face947e7f9e6846984f58bf22>>
 * @relayHash 2d7b96c2ca29a77e4c115f4b68b89278
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 516996bf29728e2f3370af3f6f1e0ba41f72b24571c9531c8a1ac7bbada3b5e9

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CsmAiWidgetBrandingChatColorVibeVariant = "DARK" | "DEFAULT" | "LIGHT" | "VIBRANT" | "%future added value";
export type CsmAiWidgetBrandingColorVibeVariant = "DARK" | "LIGHT" | "VIBRANT" | "%future added value";
export type CsmAiWidgetBrandingRadius = "NORMAL" | "ROUNDED" | "SHARP" | "%future added value";
export type CsmAiWidgetBrandingSpaceVariant = "COMFORTABLE" | "COSY" | "GENEROUS" | "%future added value";
export type CsmAiWidgetPosition = "CENTER" | "CORNER" | "%future added value";
export type supportWidgetConfigProviderQuery$variables = {
  cloudId: string;
  csm_ai_widget_in_contact_page: boolean;
  helpCenterAri: string;
};
export type supportWidgetConfigProviderQuery$data = {
  readonly csmAi_getSupportWidget: {
    readonly __typename: "CsmAiWidgetConfig";
    readonly contactPageConfig?: {
      readonly " $fragmentSpreads": FragmentRefs<"supportWidgetConfigProviderContactPage">;
    } | null;
    readonly id: string;
    readonly isEnabled: boolean | null;
    readonly position: CsmAiWidgetPosition;
    readonly theme: {
      readonly chatColor: CsmAiWidgetBrandingChatColorVibeVariant;
      readonly colorVibeVariant: CsmAiWidgetBrandingColorVibeVariant;
      readonly radius: CsmAiWidgetBrandingRadius;
      readonly space: CsmAiWidgetBrandingSpaceVariant;
    } | null;
  } | {
    readonly __typename: "QueryError";
    readonly queryError?: {
      readonly " $fragmentSpreads": FragmentRefs<"supportWidgetConfigProviderQueryError">;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly helpCenterBranding?: {
        readonly colors: {
          readonly primary: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type supportWidgetConfigProviderQuery = {
  response: supportWidgetConfigProviderQuery$data;
  variables: supportWidgetConfigProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "csm_ai_widget_in_contact_page"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "HelpCenterBranding",
      "kind": "LinkedField",
      "name": "helpCenterBranding",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterBrandingColors",
          "kind": "LinkedField",
          "name": "colors",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "primary"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "isEnabled"
},
v9 = {
  "kind": "ScalarField",
  "name": "position"
},
v10 = {
  "concreteType": "CsmAiWidgetBrandingTheme",
  "kind": "LinkedField",
  "name": "theme",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorVibeVariant"
    },
    {
      "kind": "ScalarField",
      "name": "radius"
    },
    {
      "kind": "ScalarField",
      "name": "space"
    },
    {
      "kind": "ScalarField",
      "name": "chatColor"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "supportWidgetConfigProviderQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getSupportWidget",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "condition": "csm_ai_widget_in_contact_page",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "supportWidgetConfigProviderContactPage"
                        }
                      ],
                      "type": "CsmAiWidgetConfig"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contactPageConfig"
                  }
                ]
              },
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "type": "CsmAiWidgetConfig"
          },
          {
            "condition": "csm_ai_widget_in_contact_page",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "supportWidgetConfigProviderQueryError"
                        }
                      ],
                      "type": "QueryError"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "queryError"
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "supportWidgetConfigProviderQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getSupportWidget",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "condition": "csm_ai_widget_in_contact_page",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "contactPageExperience"
                  }
                ]
              }
            ],
            "type": "CsmAiWidgetConfig"
          },
          {
            "condition": "csm_ai_widget_in_contact_page",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "identifier"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "516996bf29728e2f3370af3f6f1e0ba41f72b24571c9531c8a1ac7bbada3b5e9",
    "metadata": {},
    "name": "supportWidgetConfigProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6dd9582237b5e50bf8e1a101130e2508";

export default node;
